import { render, staticRenderFns } from "./CourseList.vue?vue&type=template&id=752efc82&scoped=true"
import script from "./CourseList.vue?vue&type=script&lang=js"
export * from "./CourseList.vue?vue&type=script&lang=js"
import style0 from "./CourseList.vue?vue&type=style&index=0&id=752efc82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752efc82",
  null
  
)

export default component.exports